import React, { useState, useEffect } from 'react';
import '../../CSS/Faq.css';
import { useLanguageData } from '../../hooks/useLanguageData';
import { useTranslation } from 'react-i18next'; // Ajouter l'import
import i18n from '../../i18n';

const FaqComponent = () => {
  const [openItems, setOpenItems] = useState([]);
  const [faqData, setFaqData] = useState([]);
  const [visibleItems, setVisibleItems] = useState(3);
  const { t } = useTranslation(); // Hook de traduction
  
  // Utilisation du hook personnalisé pour charger les données selon la langue
  const { data, loading, error } = useLanguageData('/api/v1/ambassade/category-with-faq');

  // Transformer les données API en format utilisable par le composant
  useEffect(() => {
    if (data?.data && Array.isArray(data.data)) {
      console.log("🔍 Données API FAQ transformées:", data);
      
      const allFaqItems = data.data.flatMap(category => 
        category.list_faq.map(faq => ({
          question: faq.question,
          answer: faq.response,
          category: category.label
        }))
      );
      setFaqData(allFaqItems);
    } else {
      setFaqData([]);
    }
  }, [data]);

  const toggleItem = (index) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(item => item !== index)
        : [...prev, index]
    );
  };

  // Fonction pour afficher le HTML de manière sécurisée
  const renderAnswer = (htmlContent) => {
    return (
      <div 
        className="faq-answer-content"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  };

  // Composant de spinner de chargement
  const LoadingSpinner = () => (
    <div className="faq-container">
      <h1>FOIRE AUX QUESTIONS</h1>
      <div style={{ 
        textAlign: 'center', 
        padding: '40px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          width: "50px",
          height: "50px",
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #1a3c5e",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          marginBottom: "1rem"
        }}></div>
        
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );

  // Gestion des erreurs
  if (error) {
    return (
      <div className="faq-container">
        <h1>{t('Faq.title')}</h1>
        <div style={{ 
          textAlign: 'center', 
          padding: '40px 20px',
          color: '#dc3545'
        }}>
          <p>Une erreur est survenue lors du chargement des FAQ.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#0a3764',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="faq-container">
      <h1>{t('Faq.title')}</h1>
      
      {faqData.length === 0 ? (
        <p style={{ textAlign: 'center', padding: '20px' }}>
          Aucune FAQ disponible pour le moment
        </p>
      ) : (
        <>
          {faqData.slice(0, visibleItems).map((item, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => toggleItem(index)}>
                <h2>{item.question}</h2>
                <span className={`arrow ${openItems.includes(index) ? 'open' : ''}`}>▼</span>
              </div>
              <div className={`faq-answer ${openItems.includes(index) ? 'open' : ''}`}>
                {renderAnswer(item.answer)}
              </div>
            </div>
          ))}
          
          {visibleItems < faqData.length && (
            <button 
              className="voir-plus" 
              onClick={() => setVisibleItems(faqData.length)}
            >
              {t('Faq.bottomMore')}
            </button>
          )}

          {visibleItems > 3 && visibleItems === faqData.length && (
            <button 
              className="voir-plus" 
              onClick={() => setVisibleItems(3)}
              style={{ marginTop: '10px' }}
            >
              {t('Faq.bottomLess')}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default FaqComponent;